<template>
  <div class="flex items-center">
    <VueInlineSvg
      class="svg-icon"
      v-bind="$attrs"
      :width="width || size"
      :height="height || size"
      @loaded="loaded"
      @error="loaded"
    />
    <q-skeleton
      v-if="isLoading && !withOutSkeleton"
      type="circle"
      :width="skeletonSize || width || size"
      :height="skeletonSize || height || size"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';

import VueInlineSvg from 'vue-inline-svg';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  size: {
    type: String,
    default: '24px',
  },
  skeletonSize: {
    type: String,
    default: null,
  },
  width: {
    type: String,
    default: null,
  },
  height: {
    type: String,
    default: null,
  },
  withOutSkeleton: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['loaded']);

const isLoading = ref(true);

function loaded() {
  isLoading.value = false;
  emit('loaded');
}
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: currentcolor;
}
</style>
